// ColdFusion Consulting Individual Page 
// Custom Javascript to handle the reCAPTCHA validation on the contact form
// cf_cons_ prefix means ColdFusion Consulting

const initCfConsultingPage = () => {

    const cf_cons_form = document.querySelector( '#cf-consulting-contactForm' );
    const cf_cons_recaptchaContainer = document.getElementById( 'cf-consulting-recaptcha-container' );

    if ( cf_cons_form && cf_cons_recaptchaContainer ) {

        // Ensure the default state is hidden until the user attempts to submit
        cf_cons_recaptchaContainer.classList.add( 'recaptcha-hidden' );
        cf_cons_recaptchaContainer.classList.remove( 'show' );

        cf_cons_form.addEventListener( 'submit', function( e ) {

            const hasGrecaptcha = typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.getResponse === 'function';
            const recaptchaResponse = hasGrecaptcha ? window.grecaptcha.getResponse() : '';

            if ( recaptchaResponse === '' ) {
                e.preventDefault();

                cf_cons_recaptchaContainer.classList.add( 'show' );

                cf_cons_recaptchaContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }

        });

    }
}

export default initCfConsultingPage;